import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown, Check } from 'lucide-react';
import { GroupId, GROUPS } from '../../config/systemConfig';
interface GroupSelectorProps {
  selectedGroup: GroupId;
  onSelect: (group: GroupId) => void;
  isCollapsed?: boolean;
}
export function GroupSelector({
  selectedGroup,
  onSelect,
  isCollapsed = false
}: GroupSelectorProps) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  if (isCollapsed) {
    return <div className="flex justify-center mb-6" data-id="element-991">
        <button onClick={() => setIsOpen(!isOpen)} className="w-10 h-10 rounded-xl bg-indigo-600 text-white flex items-center justify-center font-bold shadow-md hover:bg-indigo-700 transition-colors" title={`Huidige groep: ${selectedGroup}`} data-id="element-992">
          {selectedGroup}
        </button>
      </div>;
  }
  return <div className="px-3 mb-6 relative" ref={containerRef} data-id="element-993">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-3 rounded-xl bg-white border-2 border-slate-100 hover:border-indigo-200 hover:bg-slate-50 transition-all group" data-id="element-994">
        <div className="flex items-center gap-3" data-id="element-995">
          <div className="w-8 h-8 rounded-lg bg-indigo-100 text-indigo-700 flex items-center justify-center font-bold" data-id="element-996">
            {selectedGroup}
          </div>
          <div className="text-left" data-id="element-997">
            <span className="text-xs font-bold text-slate-400 uppercase tracking-wider block" data-id="element-998">
              Huidige Groep
            </span>
            <span className="font-bold text-slate-900" data-id="element-999">
              Groep {selectedGroup}
            </span>
          </div>
        </div>
        <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-1000" />
      </button>

      {/* Dropdown */}
      {isOpen && <motion.div initial={{
      opacity: 0,
      y: -10,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: -10,
      scale: 0.95
    }} className="absolute left-3 right-3 top-full mt-2 bg-white rounded-xl shadow-xl border border-slate-100 z-50 overflow-hidden" data-id="element-1001">
          <div className="p-1" data-id="element-1002">
            {GROUPS.map(group => <button key={group} onClick={() => {
          onSelect(group);
          setIsOpen(false);
        }} className={`w-full flex items-center justify-between p-3 rounded-lg transition-colors ${selectedGroup === group ? 'bg-indigo-50 text-indigo-700' : 'hover:bg-slate-50 text-slate-700'}`} data-id="element-1003">
                <div className="flex items-center gap-3" data-id="element-1004">
                  <div className={`w-6 h-6 rounded-md flex items-center justify-center font-bold text-xs ${selectedGroup === group ? 'bg-indigo-200 text-indigo-800' : 'bg-slate-100 text-slate-500'}`} data-id="element-1005">
                    {group}
                  </div>
                  <span className="font-medium" data-id="element-1006">Groep {group}</span>
                </div>
                {selectedGroup === group && <Check className="w-4 h-4 text-indigo-600" data-id="element-1007" />}
              </button>)}
          </div>
        </motion.div>}
    </div>;
}